module.exports = __webpack_public_path__ + "static/media/tickets.849ff18e.png";